import {
  SummaryContainer, SummaryCheckoutIconContainer, SummaryCheckoutCartIcon, SummaryCheckoutCartText,
  SummaryCardSummaryContainer, SummaryCheckoutCardContainer, SummaryCheckoutPlanInfoContainer, SummaryCheckoutPlanInfo,
  SummaryCheckoutPlanInfoTextContainer, SummaryCheckoutPlanInfoHeader, SummaryCheckoutPlanInfoName,
  SummaryCheckoutPlanInfoType, SummaryCheckoutPlanInfoPriceContainer, SummaryCheckoutPlanInfoPrice,
  SummaryCheckoutPlanInfoTime, SummaryCheckoutPlanInfoDisclaimer, SummaryCheckoutPlanInfoChangePlan,
  SummaryPaymentDetailsContainer, SummaryIconContainer, SummaryIcon, SummaryIconText
} from "views/PaymentFlow/Summary/Summary.styles";
import PlanCard from "components/common/PlanCard/PlanCard";
import SubscripbtionDetail from "views/PaymentFlow/Summary/SubscriptionDetail/SubscripbtionDetail";
import {useNavigate} from "react-router-dom";

interface SummaryProps {
  planJson: BenevPlan
}

function Summary(props: SummaryProps) {
  const {planJson} = props;
  const navigate = useNavigate();

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0
  });

  const details = planJson.paymentDetails.map((detail, index) => {
    return (
      <SubscripbtionDetail detail={detail} key={index}/>
    );
  })

  return (
    <SummaryContainer>
      <SummaryCheckoutIconContainer>
        <SummaryCheckoutCartIcon className={'fa-solid fa-cart-shopping'}/>
        <SummaryCheckoutCartText> Checkout </SummaryCheckoutCartText>
      </SummaryCheckoutIconContainer>

      <SummaryCardSummaryContainer>
        <SummaryCheckoutCardContainer>
          <PlanCard planJson={planJson}/>
        </SummaryCheckoutCardContainer>
        <SummaryCheckoutPlanInfoContainer>
          <SummaryCheckoutPlanInfo>
            <SummaryCheckoutPlanInfoTextContainer>
              <SummaryCheckoutPlanInfoHeader>ORGANIZATION PLANS</SummaryCheckoutPlanInfoHeader>
              <SummaryCheckoutPlanInfoName>{planJson.organizationType + " " + planJson.name}</SummaryCheckoutPlanInfoName>
              <SummaryCheckoutPlanInfoType>Monthly Subscription</SummaryCheckoutPlanInfoType>
            </SummaryCheckoutPlanInfoTextContainer>

            <SummaryCheckoutPlanInfoTextContainer>
              <SummaryCheckoutPlanInfoPriceContainer>
                <SummaryCheckoutPlanInfoPrice>{formatter.format(planJson.price / 100)}&nbsp;</SummaryCheckoutPlanInfoPrice>
                <SummaryCheckoutPlanInfoTime> / month </SummaryCheckoutPlanInfoTime>
              </SummaryCheckoutPlanInfoPriceContainer>
              <SummaryCheckoutPlanInfoDisclaimer>
                *price subject to change upon add.
                purchases
              </SummaryCheckoutPlanInfoDisclaimer>
            </SummaryCheckoutPlanInfoTextContainer>

            <SummaryCheckoutPlanInfoChangePlan onClick={() => navigate('/payments')}>
              Change Plan
            </SummaryCheckoutPlanInfoChangePlan>
          </SummaryCheckoutPlanInfo>
        </SummaryCheckoutPlanInfoContainer>


      </SummaryCardSummaryContainer>

      <SummaryIconContainer>
        <SummaryIcon className={'fa-solid fa-file-lines'}/>
        <SummaryIconText> Subscription Summary </SummaryIconText>
      </SummaryIconContainer>
      <SummaryPaymentDetailsContainer>
        {details}
      </SummaryPaymentDetailsContainer>
    </SummaryContainer>
  )
}

export default Summary;
